import React from 'react';
import * as LucideIcons from 'lucide-react';
import { ChevronRightIcon } from 'lucide-react';
interface MetricCardProps {
  data: {
    id: string;
    title: string;
    subtitle: string;
    color: string;
    textColor: string;
    points: string;
    count: string;
    rate: string;
    maxPoints: string;
    maxCount: string;
    icon: string;
    isSpeed?: boolean;
    isPenalty?: boolean;
  };
  onClick?: () => void;
}
export function MetricCard({
  data,
  onClick
}: MetricCardProps) {
  // @ts-ignore - dynamic icon loading
  const Icon = LucideIcons[data.icon] || LucideIcons.HelpCircleIcon;
  const isClickable = !!onClick;
  const subPillColor = data.isPenalty ? 'text-[#DC2626] border-red-200 bg-red-50' : data.id === 'conditions' ? 'text-[#16A34A] border-green-200 bg-green-50' : data.id === 'cd' ? 'text-[#7C3AED] border-purple-200 bg-purple-50' : data.id === 'speed' ? 'text-[#E8801F] border-orange-200 bg-orange-50' : 'text-[#2563EB] border-blue-200 bg-blue-50';
  const earnedPct = data.isPenalty ? 0 : Math.min(100, parseInt(data.points.replace(/,/g, '')) / Math.max(1, parseInt(data.maxPoints.replace(/,/g, ''))) * 100);
  return <button type="button" onClick={onClick} disabled={!isClickable} className={`group relative text-left bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col h-full w-full transition-all ${isClickable ? 'cursor-pointer hover:shadow-md hover:border-[#0A1F5C]/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0A1F5C]/40' : ''}`} data-id="element-213">
      {isClickable && <div className="absolute top-2.5 right-2.5 opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity flex items-center gap-0.5 text-[9px] font-bold text-[#0A1F5C] uppercase tracking-wider pointer-events-none" data-id="element-214">
          View
          <ChevronRightIcon className="w-3 h-3" data-id="element-215" />
        </div>}

      <div className="p-5 flex flex-col items-center text-center flex-1" data-id="element-216">
        <div className={`w-12 h-12 rounded-full ${data.color} text-white flex items-center justify-center mb-4`} data-id="element-217">
          <Icon className="w-6 h-6" data-id="element-218" />
        </div>

        <div className="h-10 flex flex-col justify-center mb-2" data-id="element-219">
          <h3 className="text-[11px] font-bold text-[#0A1F5C] uppercase leading-tight tracking-wide" data-id="element-220">
            {data.title}
          </h3>
          <p className="text-[9px] font-semibold text-gray-500 uppercase mt-0.5 tracking-wider" data-id="element-221">
            {data.subtitle}
          </p>
        </div>

        <div className="my-3" data-id="element-222">
          <span className={`text-4xl font-bold tabular-nums tracking-tight ${data.textColor}`} data-id="element-223">
            {data.points}
          </span>
          <span className="block text-[9px] font-bold text-gray-400 uppercase mt-1 tracking-wider" data-id="element-224">
            Points
          </span>
        </div>

        <div className="w-full grid grid-cols-2 gap-3 border-t border-gray-100 pt-4 mt-auto" data-id="element-225">
          <div className="flex flex-col items-center justify-center" data-id="element-226">
            <span className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider mb-1" data-id="element-227">
              {data.isPenalty ? 'At Risk' : data.isSpeed ? 'Fast Files' : data.id === 'closed' ? 'Closed' : data.id === 'cd' ? 'Sent' : 'Cleared'}
            </span>
            <span className="text-xl font-bold text-[#0A1F5C] tabular-nums" data-id="element-228">
              {data.count}
            </span>
            <span className="text-[9px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-229">
              Files
            </span>
          </div>

          <div className="flex items-center justify-center border-l border-gray-100 pl-3" data-id="element-230">
            <div className={`text-[9px] font-bold border rounded px-2 py-1 leading-tight text-center whitespace-pre-line ${subPillColor}`} data-id="element-231">
              {data.rate}
            </div>
          </div>
        </div>
      </div>

      {!data.isPenalty && <div className="bg-gray-50 px-4 py-2.5 border-t border-gray-100" data-id="element-232">
          <div className="flex justify-between items-center text-[10px] font-bold uppercase mb-1 tracking-wider" data-id="element-233">
            <span className="text-gray-500" data-id="element-234">Max Potential</span>
            <span className="text-[#0A1F5C] tabular-nums" data-id="element-235">
              {data.maxPoints} PTS
            </span>
          </div>
          <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-236">
            <div className={`h-full rounded-full ${data.color}`} style={{
          width: `${earnedPct}%`
        }} data-id="element-237" />
          </div>
        </div>}
    </button>;
}